import { render, staticRenderFns } from "./OfficialPush.vue?vue&type=template&id=3d1273d9&scoped=true"
import script from "./OfficialPush.vue?vue&type=script&lang=js"
export * from "./OfficialPush.vue?vue&type=script&lang=js"
import style0 from "./OfficialPush.vue?vue&type=style&index=0&id=3d1273d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1273d9",
  null
  
)

export default component.exports